module.exports = __webpack_public_path__ + "static/media/Tiger599_4c.bf32bfe1.svg";